import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import DisplayChartCard from './DisplayChartCard'; // Assuming DisplayChartCard is in the same folder
import type { Chart } from '@shared/schemas/chart';

// Revert to simpler type, order and isFavorite are not dashboard-specific chart properties here
interface DraggableChart extends Chart {
    order: number; // order is from DashboardChartItem, added when fetching in parent
}

interface DraggableDashboardChartProps {
  id: string; 
  chart: DraggableChart; // Use this simpler extended type
  onRemoveChart: (chartId: string) => void;
  onOpenStudies: (chart: Chart) => void;
  onChartDataUpdate: () => void;
  hideTitle?: boolean;
  hideEditButton?: boolean;
}

const DraggableDashboardChart: React.FC<DraggableDashboardChartProps> = (props) => {
  const { chart, id, onRemoveChart, onOpenStudies, onChartDataUpdate, hideTitle, hideEditButton } = props;

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.7 : 1,
    zIndex: isDragging ? 10 : undefined, 
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners} className="touch-manipulation">
      <DisplayChartCard 
        chart={chart}
        onRemoveChart={onRemoveChart} 
        onOpenStudies={onOpenStudies}
        onChartDataUpdate={onChartDataUpdate}
        hideTitle={hideTitle}
        hideEditButton={hideEditButton}
      />
    </div>
  );
};

export default DraggableDashboardChart; 